import { KeyValuePair } from '../types/key-value-pair';

export const getKey = <TKey, TValue>(pair: KeyValuePair<TKey, TValue>): TKey => pair[0];
export const getValue = <TKey, TValue>(pair: KeyValuePair<TKey, TValue>): TValue => pair[1];
